// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_9e1425b4d3--wrapper--YxYCu","_size_s":"_9e1425b4d3--_size_s--siKx0","_size_m":"_9e1425b4d3--_size_m--sOKj6"};